var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.253 26.555h2.204c.802 0 1.253-.451 1.253-1.253V6.113c0-.801-.451-1.252-1.253-1.252H8.253C7.45 4.86 7 5.31 7 6.113v19.19c0 .8.45 1.252 1.253 1.252zm12.274 0h2.205c.802 0 1.253-.451 1.253-1.253V6.113c0-.801-.451-1.252-1.253-1.252h-2.204c-.802 0-1.253.45-1.253 1.252v19.19c0 .8.45 1.252 1.253 1.252z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/Pause-Icon.d60a41da4317dd4397143f059794f1cb.svg";
export { ForwardRef as ReactComponent };